import { render, staticRenderFns } from "./BringOwnBadgesField.vue?vue&type=template&id=71c0993d&"
import script from "./BringOwnBadgesField.vue?vue&type=script&lang=js&"
export * from "./BringOwnBadgesField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports